import { HttpInterceptorFn } from "@angular/common/http";

export const xsrfInterceptor: HttpInterceptorFn = (req, next) => {
  if (['POST', 'PUT', 'DELETE', 'PATCH'].includes(req.method)) {
    const requestToken = localStorage.getItem('csrf-request-token');
    
    if (requestToken) {
      const modifiedReq = req.clone({
        headers: req.headers.set('X-XSRF-TOKEN', requestToken)
      });
      return next(modifiedReq);
    }
  }
  
  return next(req);
};